import React from 'react';
import ReportTemplate from '../ReportTemplateNoClick';
import { formatDollar } from '../../Utilities/GridTools';

const PaymentHistoryReport = () => {
    const columnDefs = [
        { headerName: 'Client', field: 'clientName' },
        { headerName: 'Year', field: 'yearPaid', filter: 'agNumberColumnFilter' },
        { headerName: 'Month', field: 'monthPaid', filter: 'agNumberColumnFilter' },
        { headerName: 'Project', field: 'projectId' },
        { headerName: 'Payments 1', field: 'payments1', valueFormatter: formatDollar, filter: 'agDollarColumnFilter' },
        { headerName: 'Fees 1', field: 'fee1', valueFormatter: formatDollar, filter: 'agDollarColumnFilter' },
        { headerName: 'Payments 2', field: 'payments2', valueFormatter: formatDollar, filter: 'agDollarColumnFilter' },
        { headerName: 'Fees 2', field: 'fee2', valueFormatter: formatDollar, filter: 'agDollarColumnFilter' },
        { headerName: 'Files 1', field: 'totalFiles1', filter: 'agNumberColumnFilter' }
    ];

    const apiUrl = `${process.env.REACT_APP_API_URL}/Reports/Executive/PaymentHistoryReportGroup`;

    return (
        <ReportTemplate columnDefs={columnDefs} apiUrl={apiUrl} reportName={'Payment History group'} />
    );
};  


export default PaymentHistoryReport;